import Global from "./general/global";
import Nav from "./general/nav";
import Home from "./pages/home";
import Taxaties from "./pages/taxaties";
import Property from "./properties/property";
import Project from "./projects/project";
import Molenwijk from "./projects/molenwijk";
import HuisVerkopen from "./pages/huisverkopen";
import Park from "./parks/park";
import Contact from "./pages/contact";
import Diensten from "./pages/diensten";

require('./bootstrap');

new Global();
new Nav();
new Home();
new Taxaties();
new Property();
new Project();
new Molenwijk();
new HuisVerkopen();
new Diensten();
new Park();
new Contact();
